import React from 'react';
import { cx } from '../components/styles';
import { CONTAINER } from './landingConfig';

/**
 * Section 3. Honest, checkable proof that costs nothing, sitting where a
 * "trusted by thousands" line would otherwise go.
 *
 * Rendered as styled text, NOT logo files: using these trademarks as logos needs
 * permission we do not have.
 *
 * NEEDS INPUT (DESIGN_PLAN open question 4): whether the DICE / AXS / TAO /
 * CrowdVolt names may appear on marketing material at all. That is a legal call,
 * not a design one. If the answer is no, this section and bento tiles 4–6 and
 * FAQ 1 all need rewording.
 */
const PLATFORMS = ['DICE', 'AXS', 'TAO', 'CrowdVolt'];

export const IntegrationStrip: React.FC = () => (
  <section className="border-y border-white/[0.06] py-10">
    <div className={cx(CONTAINER, 'flex flex-col items-center gap-5')}>
      <p className="text-xs uppercase tracking-widest text-white/30">WORKS WITH</p>
      <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
        {PLATFORMS.map((name) => (
          <li
            key={name}
            className="text-xl font-semibold tracking-tight text-white opacity-50 transition-opacity hover:opacity-80"
          >
            {name}
          </li>
        ))}
      </ul>
    </div>
  </section>
);
